import { RefinePriceSchemaType } from '../../form/schema';
import constants from '../../../../ahm-constants';
import GA4Analytics from '../../../../analytics/ga4-analytics';

export const getChangedLeadFieldsForGa = ({ email, phone }: Pick<RefinePriceSchemaType, 'email' | 'phone'>) =>
  [phone && 'phone', email && 'email'].filter(Boolean).join(' | ') || 'none provided';

const submitRefinePriceAnalytics = (values: RefinePriceSchemaType) => {
  const { email, phone } = values;
  const changedFields = getChangedLeadFieldsForGa({ email, phone });

  GA4Analytics.submit({
    // eslint-disable-next-line camelcase
    data: { changed_fields: changedFields },
    name: constants.ANALYTICS.EVENTS.ECOMMERCE_GA4.REFINE_PRICE,
  });
};

export default submitRefinePriceAnalytics;
